import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import { FaSpinner } from 'react-icons/fa';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const userEmail = localStorage.getItem('userEmail');
    const token = localStorage.getItem('token');
    const id = localStorage.getItem('id');

    if (!userEmail || !token || !id) {
      setIsAuthenticated(false);
      return;
    }

    axios.get(`${process.env.REACT_APP_API_BASE_URL}/clients/${id}`)
      .then(clientResponse => {
        const ownerEmail = clientResponse.data.email;

        axios.post(`${process.env.REACT_APP_API_BASE_URL}/sessions/check`, {
          email: userEmail,
          token: token,
        })
          .then(sessionResponse => {
            if (userEmail.toLowerCase() === ownerEmail.toLowerCase()) {
              setIsAuthenticated(true);
            } else {
              console.log('Logged in email does not match owner email.');
              localStorage.removeItem('userEmail');
              localStorage.removeItem('token');
              // localStorage.removeItem('id');
              setIsAuthenticated(false);
            }
          })
          .catch(sessionError => {
            console.error('Error checking session:', sessionError);
            localStorage.removeItem('userEmail');
            localStorage.removeItem('token');
            // localStorage.removeItem('id');
            setIsAuthenticated(false);
          });
      })
      .catch(clientError => {
        console.error('Error fetching client data:', clientError);
        localStorage.removeItem('userEmail');
        localStorage.removeItem('token');
        // localStorage.removeItem('id');
        setIsAuthenticated(false);
      });
  }, []);

  if (isAuthenticated === null) {
    return (
      <div className="max-w-4xl mx-auto py-10 px-2 text-center">
        <div className="flex justify-center items-center">
          <FaSpinner className="animate-spin text-primary text-4xl" />
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
